import React from 'react';
import PropTypes from 'prop-types';
import styles from './ConfirmSubmissionModal.module.css';

const ConfirmSubmissionModal = ({ onClose, onReject, onConfirm }) => {
  const handleClose = () => {
    console.log("Action: Close overlay");
    onClose();
  };

  const handleReject = () => {
    console.log("State=Cancel; Action: Close overlay");
    onReject();
  };

  const handleConfirm = () => {
    console.log("State=Default; Action: Close overlay");
    onConfirm();
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.container}>
        <button className={styles.closeButton} onClick={handleClose} aria-label="Close">
          &times;
        </button>
        <div className={styles.titleContainer}>
          <h1 className={styles.titleText}>Confirm Submission</h1>
        </div>
        <div className={styles.descriptionContainer}>
          <p className={styles.descriptionText}>
            Please ensure the report contains all required information. Once approved, this report will be marked as complete, and no further changes may be made.
          </p>
        </div>
        <div className={styles.buttonContainer}>
          <button className={styles.rejectButton} onClick={handleReject}>Reject Report</button>
          <button className={styles.confirmButton} onClick={handleConfirm}>Confirm WATCH Report</button>
        </div>
      </div>
    </div>
  );
};

ConfirmSubmissionModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onReject: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmSubmissionModal;
